import cx from 'classnames';
import PropTypes from 'prop-types';
// biome-ignore lint/correctness/noUnusedImports: existing error
import React from 'react';

import {Breadcrumb} from '~/GalleryPB/Breadcrumb';
import {isIn3AcrossABTest} from '~/GalleryPB/experiments';
import {FilterPreviewer} from '~/GalleryPB/FilterPreviewer';
import {PageTitle} from '~/GalleryPB/PageTitle';
import {SeoHeader} from '~/GalleryPB/SeoHeader';
import {showSeoHeader} from '~/GalleryPB/utils';
import {useMatchQuery} from '~library/hooks/useMatchQuery';
import {largishAndUpQuery} from '~libSass/base/_exports.sass';
import {TopFiltersAB} from './AB4Across/TopFiltersAB';

export const Header = ({
  crumbPath,
  pageTitle,
  numTemplates,
  activeFilters,
  onFilterDismiss,
  onClearAllFilters,
  filtersData,
  relatedCategories,
  galleryUploadComponent,
}) => {
  const renderFiltersAB = !!filtersData && Object.keys(filtersData).length > 0;
  const {matches: largeScreens} = useMatchQuery(`(${largishAndUpQuery})`);
  const in3AcrossABTest = isIn3AcrossABTest();

  return (
    <div
      className={cx('gallery__header', {
        'seo-heading': showSeoHeader,
        'default-heading': renderFiltersAB,
      })}
    >
      {!in3AcrossABTest && showSeoHeader
        ? <>
            <Breadcrumb path={crumbPath} />
            <SeoHeader
              title={pageTitle}
              numTemplates={numTemplates}
              filtersData={filtersData}
              relatedCategories={relatedCategories}
              onFilterDismiss={onFilterDismiss}
              activeFilters={activeFilters}
              onClearAllFilters={onClearAllFilters}
              renderFiltersAB={renderFiltersAB}
              galleryUploadComponent={galleryUploadComponent}
            />
          </>
        : <>
            {!showSeoHeader && (
              <>
                <Breadcrumb path={crumbPath} />
                <div className="gallery__title-filters-wrapper">
                  {pageTitle && numTemplates !== undefined && (
                    <PageTitle text={pageTitle} numTemplates={numTemplates} />
                  )}
                  {!filtersData && largeScreens && (
                    <FilterPreviewer
                      filters={activeFilters}
                      onFilterDismiss={onFilterDismiss}
                      onClearAllFilters={onClearAllFilters}
                    />
                  )}
                </div>
              </>
            )}
            {window.webflow_content && (
              <div
                id="category_webflow"
                // biome-ignore lint/security/noDangerouslySetInnerHtml: existing error
                // biome-ignore lint/style/useNamingConvention: existing error
                dangerouslySetInnerHTML={{__html: window.webflow_content}}
              />
            )}
            {renderFiltersAB
              ? <TopFiltersAB
                  activeFilters={activeFilters}
                  filtersData={filtersData}
                  relatedCategories={relatedCategories}
                  numTemplates={numTemplates}
                  onFilterDismiss={onFilterDismiss}
                  onClearAllFilters={onClearAllFilters}
                  galleryUploadComponent={galleryUploadComponent}
                />
              : galleryUploadComponent}
          </>}
    </div>
  );
};

Header.propTypes = {
  crumbPath: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
    })
  ).isRequired,
  pageTitle: PropTypes.string.isRequired,
  numTemplates: PropTypes.number,
  activeFilters: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onFilterDismiss: PropTypes.func,
  onClearAllFilters: PropTypes.func,
};
